import { useState, useEffect, memo, useLayoutEffect } from "react";
import { Link, Outlet } from "react-router-dom";
// material
import { styled, useTheme } from "@material-ui/core/styles";
// hooks
import useCollapseDrawer from "../../hooks/useCollapseDrawer";
//
import DashboardNavbar from "./DashboardNavbar";
import DashboardSidebar from "./DashboardSidebar";
import ListMessageBubble from "./ListMessageBubble";
import { useDispatch, useSelector } from "../../redux/store";
import { getInfoZalo, getListZaloOa } from "../../redux/slices/zalo";
import { getInfoFacebook, loadListPage } from "../../redux/slices/facebook";
import { InitIO } from "../../redux/slices/io";
//import { getConversations, getContacts } from '../../redux/slices/chat';
import { getAllFieldTicket } from "../../redux/slices/ticket";
import { InitJanus } from "../../redux/slices/janus";
import {
    listNotification,
    viewNotification,
} from "../../redux/slices/notification";
import { useSnackbar } from "notistack5";
import useAuth from "../../hooks/useAuth";
import apiPbx from "../../api/pbx";
import { InitJanusVideo } from "../../redux/slices/janusVideo";
import {
    Box,
    Button,
    IconButton,
    Modal,
    Stack
} from "@material-ui/core";
import { Icon } from "@iconify/react";
import apiUser from "../../api/user";

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;

const RootStyle = styled("div")({
    display: "flex",
    minHeight: "100%",
    overflow: "unset",
});

const MainStyle = styled("div")(({ theme }) => ({
    flexGrow: 1,
    overflow: "auto",
    minHeight: "100%",
    // paddingTop: APP_BAR_MOBILE + 24,
    paddingTop: APP_BAR_MOBILE + 4,
    paddingBottom: theme.spacing(10),
    [theme.breakpoints.up("lg")]: {
        // paddingTop: APP_BAR_DESKTOP + 24,
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
}));
const ModalDecreeStyle = styled("div")(({ theme }) => ({
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 600,
    background: "#fff",
    borderRadius: "15px",
    overflow: "hidden",
    outline: "none",
    //border: '2px solid #000',
    //boxShadow: 24,
}));

// ----------------------------------------------------------------------

export default memo(function DashboardLayout() {
    console.log("DashboardLayout Render");
    const theme = useTheme();
    const { collapseClick } = useCollapseDrawer();
    const [open, setOpen] = useState(false);
    const [isOpenModal, setIsOpenModal] = useState(true);
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { user } = useAuth();
    const { notify_content } = useSelector((state) => state.io);
    const [isConfirm, setIsConfirm] = useState(true);

    const [isPopupNoti, setIsPopupNoti] = useState(true);
    useEffect(() => {
        if (notify_content) {
            enqueueSnackbar(notify_content, { variant: "warning" });
        }
    }, [notify_content]);

    useEffect(() => {
        const day3004 = new Date(2024, 3, 30);
        const presentDate = new Date();

        if (presentDate > day3004) {
            setIsPopupNoti(true);
        } else {
            const date = new Date().getDate();
            const initIsPopupNoti = JSON.parse(
                localStorage.getItem(user.email)
            );
            if (initIsPopupNoti) {
                setIsPopupNoti(initIsPopupNoti[date]);
            }
        }
    }, []);
    useLayoutEffect(() => {
        const get_sip_config = async () => {
            try {
                const res = await apiPbx.find_sip_config_selected();
                const item = res.data.data;
                var pbx = item.ip_pbx;
                if (item?.type_dial === "PJSIP") {
                    pbx = item.ip_pbx + ":5999";
                }
                dispatch(
                    InitJanus({
                        ipSip: pbx,
                        sip: item.sip_number,
                        secret: item.sip_password,
                    })
                );
            } catch (error) {
                //enqueueSnackbar("Lấy thông tin SIP lỗi!", { variant: 'error' });
            }
        };
        const reload = async () => {
            //Kiem tra nghi dinh
            const res_confirm_decree = await apiUser.check_confirm_decree({});
            if (res_confirm_decree) {
                setIsConfirm(res_confirm_decree.data.data.is_confirm);
            }

            //
            await get_sip_config();
            //dispatch(getInfoZalo());

            // dispatch(getConversations());
            dispatch(loadListPage(user));
            dispatch(getListZaloOa());
            dispatch(getAllFieldTicket());
            dispatch(viewNotification());
            dispatch(listNotification());
            dispatch(InitIO());
            dispatch(InitJanusVideo(user.id));
        };
        reload();
    }, [dispatch]);
    const onHandleNavigateURL = () => {
        window.open(
            "https://voip24h.vn/chinh-sach-bao-mat-thong-tin/",
            "_blank",
            "toolbar=0,location=0,menubar=0"
        );
    };
    const onConfirmDecree = async () => {
        try {
            await apiUser.confirm_decree({});
            setIsConfirm(true);
        } catch (error) {}
    };

    const handleClosePopupNoti = () => {
        setIsPopupNoti(true);
        const infoNotification = JSON.parse(localStorage.getItem(user.email));
        const date = new Date().getDate();
        infoNotification[date] = true;

        localStorage.setItem(user.email, JSON.stringify(infoNotification));
    };
    return (
        <RootStyle>
            <div className="hide" id="audiostream"></div>
            {!isConfirm && (
                <Modal
                    open={isOpenModal}
                    onClose={() => setIsOpenModal(false)}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <ModalDecreeStyle>
                        <Box sx={{ position: "absolute", top: 0, right: 2 }}>
                            <IconButton
                                onClick={() => setIsOpenModal(false)}
                                sx={{ color: "white" }}
                            >
                                <Icon
                                    icon={"material-symbols-light:close"}
                                    width={20}
                                    height={20}
                                />
                            </IconButton>
                        </Box>
                        <Stack direction={"column"}>
                            <img width="100%" alt="notice_of_decree" src="/images/notice_of_decree/img-decree.jpg"/>
                            <Box
                                sx={{ py: 1, px: 3 }}
                                display={"flex"}
                                flexDirection={"row"}
                                justifyContent={"space-between"}
                                style={{
                                    backgroundImage:
                                        "linear-gradient(to bottom right,#0356d8 , #469edc)",
                                }}
                            >
                                <Button
                                    onClick={() => onConfirmDecree()}
                                    sx={{ color: "white", fontWeight: "bold" }}
                                >
                                    {" "}
                                    Xác nhận{" "}
                                </Button>
                                <IconButton
                                    onClick={() => onHandleNavigateURL()}
                                    sx={{ color: "white" }}
                                >
                                    <Icon
                                        icon={"ep:arrow-right-bold"}
                                        width={20}
                                        height={20}
                                    />
                                </IconButton>
                            </Box>
                        </Stack>
                    </ModalDecreeStyle>
                </Modal>
            )}

            {!isPopupNoti && (
                <Modal
                    tabindex={0}
                    open={!isPopupNoti}
                    onClose={handleClosePopupNoti}
                >
                    <ModalDecreeStyle>
                        <Box sx={{ position: "absolute", top: 0, right: 2 }}>
                            <IconButton
                                onClick={handleClosePopupNoti}
                                sx={{ color: "white" }}
                            >
                                <Icon
                                    icon={"material-symbols-light:close"}
                                    width={20}
                                    height={20}
                                />
                            </IconButton>
                        </Box>
                        <Link
                            target="_blank"
                            to="https://voip24h.vn/thong-bao-bao-tri-may-chu-nang-cap-he-thong-voip24h/"
                        >
                            <img
                                alt="notice_of_decree"
                                width="100%"
                                src="/images/notice_of_decree/maintance.png"
                            />
                        </Link>
                    </ModalDecreeStyle>
                </Modal>
            )}

            <DashboardNavbar onOpenSidebar={() => setOpen(true)} />
            <DashboardSidebar
                isOpenSidebar={open}
                onCloseSidebar={() => setOpen(false)}
            />

            <MainStyle
                sx={{
                    transition: theme.transitions.create("margin", {
                        duration: theme.transitions.duration.complex,
                    }),
                    ...(collapseClick && {
                        ml: "102px",
                    }),
                }}
            >
                <Outlet />
            </MainStyle>
        </RootStyle>
    );
});
